module.exports = __webpack_public_path__ + "img/Bryn.d8e3e6f9.png";